import { render } from "./TransportCostFormulaModal.vue?vue&type=template&id=66dfdfb5&scoped=true"
import script from "./TransportCostFormulaModal.vue?vue&type=script&lang=js"
export * from "./TransportCostFormulaModal.vue?vue&type=script&lang=js"

import "./TransportCostFormulaModal.vue?vue&type=style&index=0&id=66dfdfb5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66dfdfb5"]])

export default __exports__